export default __webpack_public_path__ + "static/media/Necklace.e05e0d44.png";